import { mapGetters } from "vuex";

export default {
    name: "order-item",
    props: ["product"],
    computed: {
        ...mapGetters({
            user: "profile/user",
        }),
        bonusesFromItem() {
            let bonuses = this.product.price - this.product.min_price;
            let percentOfBonuses = (bonuses * 19.5) / 100;
            return ((bonuses - percentOfBonuses) * this.product.select_count).toFixed(2);
        },
    },
};
